import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=a1303a04&scoped=true"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"
import style0 from "./Delete.vue?vue&type=style&index=0&id=a1303a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1303a04",
  null
  
)

export default component.exports